import dayjs from './date';

export const secondsToTimestamp = (seconds: number, separator = ':') => {
  const sec = (seconds % 60).toString().padStart(2, '0');
  const min = Math.floor((seconds / 60) % 60)
    .toString()
    .padStart(2, '0');
  const hour = Math.floor(seconds / 3600)
    .toString()
    .padStart(2, '0');

  if (Number(hour) > 0) {
    return `${hour}${separator}${min}${separator}${sec}`;
  } else {
    return `${min}${separator}${sec}`;
  }
};

/**
 * 2025-07-14 18:15:00 -> 2025.07.14
 */
export function formatDateToYYYYMMDD(date: string) {
  return dayjs(date).format('YYYY.MM.DD');
}

/**
 * 2025-07-14 18:15:00 -> 2025년 4월 20일 23:23 까지
 */
export function formatDateToYYYYMDHHMM(date: string) {
  return dayjs(date).format('YYYY년 M월 D일 HH:mm');
}

/**
 * 2025-07-14 18:15:00 -> 2025년 4월 20일
 */
export function formatDateToYYYYMDWithUnit(date: string) {
  return dayjs(date).format('YYYY년 M월 D일');
}
